require('./sgt');
(function($, window, document, undefined) {
	$(function(){
		//cep autocomplete
		$('body').on('keyup','.container-endereco [alt=cep]', function() {
			var $self = $(this);
			var $container = $self.closest('.container-endereco');
			var cep = $self.val().replace(/\D/gim,'');
			if (cep.length != 8) return;
			$.fancybox.showLoading();
			SGT.location.getLogradouro(cep, function(resp) {
				$.fancybox.hideLoading();
				if (!resp) return;
				$.each(resp,function(name, value) {
					$container.find(`[name*=${name}]`).val(value);
				});
			});
		});
		//duplicar endereço
		$('body').on('click','.btn-add-endereco', function() {
			var $self = $(this);
			var $target = $('.address-target');

			var $clone = $('.container-endereco:first').clone();
			$clone.find(':text,select').val('');
			$clone.find(':radio').prop('checked',false);
			$clone.find('.btn-add-endereco').remove();

			var last_index = $('.container-endereco:last [name*=cep]').attr('name').replace(/\D/igm,'')|0;
			var index = last_index + 1;
			$clone.find(':radio').val(index);
			$clone.find('[name*=id], :text, select').each(function() {
				var $el = $(this);
				var name = $el.attr('name');
				name = name.replace(/\d+/igm, index);
				$el.attr('name',name);
			});
			$clone.find('[name*=id]').val(0);


			$clone.appendTo($target);
		});
		//salvar cadastro
		$('body').on('submit','[name=formCadastro]', function() {
			var $self = $(this);
			try	{
				if ($self.data('enviando')) {
					return false;
				}
				if (!$self.find('.required').validate()) {
					return false;
				}
				$self.data('enviando',true);
				$.fancybox.showLoading();
				var callback = function(resp) {

					if (/carrinho\/cadastro$/.test(location.pathname)) {
						if (resp.success) {
							location.reload(true);
							return;
						}
					}

					if (undefined !== resp.redirect_url) {
						location.href = resp.redirect_url;
						return;
					}
					$.fancybox.hideLoading();
					$self.data('enviando',false);
					if (undefined !== resp.popup_url) {
						$.fancybox.open([{
							href: resp.popup_url,
							type: 'ajax'
						}],{});
						return;
					}
					alert(resp.msg);
					if (resp.success) {
						location.href = "cliente/index";
					}
				};
				$.ajax({
					url: $self.attr('action'),
					type: 'post',
					dataType: 'json',
					data: $self.serializeArray(),
					success: callback,
					error: function() {
						callback({
							success: false,
							msg: "Não foi possível enviar o formulário."
						});
					}
				});
			} catch (e) {
				console.log(e);
			}
			return false;
		});
		//login

		$('body').on('submit', '[name=formLogin]', function() {
			var $self = $(this);
			try	{
				if ($self.data('enviando')) return false;
				if (!$self.find('.required').validate()) return false;

				$self.data('enviando',true);
				$.fancybox.showLoading();

				var callback = function(resp) {
					$self.data('enviando',false);

					if (/carrinho\/identificacao$/.test(location.pathname)) {
						if (resp.success) {
							location.reload(true);
							return;
						}
					}

					if (resp.redirect_url != undefined) {
						location.href = resp.redirect_url;
						return;
					}

					if (resp.popup_url != undefined) {
						$.fancybox.open([{
							href: resp.popup_url,
							type: 'ajax'
						}],{});
						return;
					}

					if (resp.success) {
						location.href = $('base').attr('href')+'cliente/index';
						return;						
					} else {
						alert(resp.msg);
					}
					$.fancybox.hideLoading();
				};

				$.ajax({
					url: $self.attr('action'),
					type: 'post',
					dataType: 'json',
					data: $self.serializeArray(),
					success: callback,
					error: function() {
						callback({
							success: false,
							msg: "Não foi possível enviar o formulário."
						});
					}
				});
			} catch (e) {

			}
			return false;
		});

		//endereço

		$('body').on('click','.btn-remover-endereco', function() {
			var $self = $(this);
			var id = $self.data('id')|0;

			if (0 == id) {
				return false;
			}

			if ($self.data('enviando')) {
				return false;
			}

			$self.data('enviando',true);
			$.fancybox.showLoading();

			var callback = function(resp) {
				if (resp.redirect_url != undefined) {
					location.href = resp.redirect_url;
					return;
				}

				$self.data('enviando',false);

				if (resp.popup_url != undefined) {
					$.fancybox.hideLoading();
					$.fancybox.open([{
						href: resp.popup_url,
						type: 'ajax'
					}],{});
				}

				if (resp.success) {
					location.reload(true);
					return false;
				}

				$.fancybox.hideLoading();
				alert(resp.msg);
			};

			$.ajax({
				url: 'cliente/remover-endereco',
				type: 'post',
				dataType: 'json',
				data: {
					id: id
				},
				success: callback,
				error: function() {
					callback({
						success: false,
						msg: "Não foi possível remover o endereço."
					});
				}
			});

		});

		// endereço padrão

		$('body').on('change','.btn-endereco-padrao :radio', function() {
			var $self = $(this);			
			var endereco_id = $self.val();
			
			$.fancybox.showLoading();

			var callback = function(resp) {
				if (resp.redirect_url != undefined) {
					location.href = resp.redirect_url;
					return;
				}


				if (resp.popup_url != undefined) {
					$.fancybox.hideLoading();
					$.fancybox.open([{
						href: resp.popup_url,
						type: 'ajax'
					}],{});
				}

				if (!resp.success) {
					alert(resp.msg);
					location.reload(true);
					return false;
				}

				$.fancybox.hideLoading();
			};

			$.ajax({
				url: 'cliente/set-endereco-padrao',
				type: 'post',
				dataType: 'json',
				data: {
					id: endereco_id
				},
				success: callback,
				error: function() {
					callback({
						success: false,
						msg: "Não foi possível alterar o endereço padrao"
					});
				}
			});


		});
		// dados contato

		var $colunaDadosContato = $('.coluna-dados-contato');
		if (0 != $colunaDadosContato.length) {
			$('.box-dados-contato').prependTo('.coluna-dados-contato');
		}

		//fim

	});
}(jQuery, window, document));


//////////////////
// WEBPACK FOOTER
// ../src/cliente.js
// module id = 59
// module chunks = 0